import { MatSelectModule } from '@angular/material/select';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { TextFieldModule } from '@angular/cdk/text-field';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { BuyerAddressHistoryComponent } from './components/buyer-address-history/buyer-address-history.component';
import { MatHistoriaComponent } from './components/historia/historia.component';
import { MatPlikiComponent } from './components/pliki/pliki.component';
import { ColumnChooserComponent } from './components/column-chooser/column-chooser.component';
import { DocumentLinksComponent } from './components/document-links/document-links.component';
import { PagerComponent } from './components/pager/pager.component';
import { VatWarningDialogComponent } from './components/vat-warning-dialog/vat-warning-dialog.component';
import { OfficeNamesDialogComponent } from './components/office-names-dialog/office-names-dialog.component';
import { HasPermissionDirective } from '../core/permissions/has-permission.directive';
import { CopyTableValuesDirective } from './directives/copy-table-values.directive';

@NgModule({
  declarations: [
    ConfirmDialogComponent,
    BuyerAddressHistoryComponent,
    MatHistoriaComponent,
    MatPlikiComponent,
    ColumnChooserComponent,
    DocumentLinksComponent,
    PagerComponent,
    VatWarningDialogComponent,
    OfficeNamesDialogComponent,
    HasPermissionDirective,
    CopyTableValuesDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,

    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatTableModule,
    MatTabsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatDividerModule,
    MatDialogModule,
    MatSnackBarModule,
    MatListModule,
    MatExpansionModule,
    MatCardModule,
    MatTooltipModule,
    MatTreeModule,
    TextFieldModule,
    NgxMatSelectSearchModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,

    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatTableModule,
    MatTabsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatDividerModule,
    MatDialogModule,
    MatSnackBarModule,
    MatListModule,
    MatExpansionModule,
    MatCardModule,
    MatTooltipModule,
    MatTreeModule,
    TextFieldModule,
    NgxMatSelectSearchModule,

    ConfirmDialogComponent,
    BuyerAddressHistoryComponent,
    MatHistoriaComponent,
    MatPlikiComponent,
    ColumnChooserComponent,
    DocumentLinksComponent,
    PagerComponent,
    VatWarningDialogComponent,
    OfficeNamesDialogComponent,
    HasPermissionDirective,
    CopyTableValuesDirective,
  ],
})
export class SharedModule {}
